<template>
	<el-container style="height:100%;">
		<!-- 顶栏 -->
		<el-header class="top-header" style="height:50px">
			<div>

				<label style="margin:0 20px 0 5px;font-weight: bolder;font-size: 18px;">
					水滴云智能系统
				</label>
			</div>
			<div>
				<el-button size="mini" style="margin-right:20px" v-if="childList && childList.length>0"
					@click="$router.push('/cms/index')">管理数据</el-button>
				<el-dropdown trigger="hover">
					<span>
						<label class="user-name">{{info.name}} {{info.role_str}}</label>
						<el-image fit="cover" class="avatar" :src="info.avatar_url" />
					</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
						<el-dropdown-item>
							<router-link to="/profile/settings">设置信息</router-link>
						</el-dropdown-item>
						<el-dropdown-item>
							<router-link to="/profile/password">修改密码</router-link>
						</el-dropdown-item>

						<el-dropdown-item @click.native="bindWx">绑定公众号</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
		</el-header>
		<!-- 中栏 -->
		<el-header class="middle-header" style="height:80px">
			<div class="logo">
				<img :src="$store.state.school.schoolInfo.logo_url" />
				<label>{{$store.state.school.schoolInfo.name}}</label>
			</div>
			<el-menu class="el-menu-h" mode="horizontal" @select="selectApp" :default-active="app_id+''"
				style="display:flex;flex-wrap:nowrap;">
				<el-menu-item v-for="list in appList" :key="list.id" :index="list.id+''" class="nva_item">
					<i :class="'icon iconfont'+' ' + list.icon"></i>
					<div class="label">
						<span style="font-size:14px;">{{list.name}}</span>
					</div>
				</el-menu-item>
			</el-menu>
		</el-header>
		<!-- 内容区 -->
		<el-container v-loading="loading" class="content-container">
			<side-menu class="side-menu" />

			<div style="width:100%;overflow:auto">
				<router-view class="content-page" :key="$route.fullPath" />
			</div>
		</el-container>
		<el-dialog title="绑定公众号" width="300px" :visible.sync="qrcode.show">
			<div style="width:100%;height:250px;text-align: center" v-loading="qrcode.loading">
				<el-image class="qrcode_image" v-if="qrcode.url" :src="qrcode.url"></el-image>
				<div>请扫描微信二维码登录</div>
				<div>水滴智能服务号</div>
			</div>
		</el-dialog>
	</el-container>
</template>

<script>
	import { schoolUser, access, user } from "@/api/server";
	import { mapGetters, mapState } from "vuex";
	import { clearAuthorization,getAuthorization } from '@/views/login'
	import Menu from './menu.vue';
	import ArticleList from './article-list.vue'
	export default {
		components: {
			'side-menu': Menu,
			'article-list': ArticleList
		},
		data() {
			return {
				levelList: [], //面包屑
				loading: false,
				app_id: 2,
				path: "",
				appList: [],
				childList: [], //右侧菜单
				qrcode: {
					url: "",
					show: false,
					loading: false,
				},
				noticeList: [],

				is_show_bread: true,
			};
		},


		beforeRouteUpdate(to, from, next) {
			console.log('beforeRouteUpdate===', from)
			if (to.fullPath == from.fullPath) return;
			let item = to.meta;
			if (item.is_bread != undefined && item.is_bread == false) {
				this.is_show_bread = false;
			} else {
				this.is_show_bread = true;
			}
			this.handleselect(to.fullPath);
			to.meta.is_alive = true
			if (this.levelList && to.query.refresh != false && to.query.refresh != "false") {
				const index = this.levelList.findIndex(v => {
					const o = v.fullPath.indexOf("?") > -1 ? v.fullPath.substring(0, v.fullPath.indexOf("?")) : v.fullPath
					const n = to.fullPath.indexOf("?") > -1 ? to.fullPath.substring(0, to.fullPath.indexOf("?")) : to.fullPath
					return o == n
				})
				if (index > -1) {
					if (to.fullPath != this.levelList[index]) {
						this.rmCache(this.levelList[index].fullPath)
					}
					this.levelList.splice(index, this.levelList.length - index)
				}
			}
			this.levelList.push({
				name: to.query.tag || to.meta.name,
				fullPath: to.fullPath
			});

			next();
			this.isInit();
		},


		computed: {
			...mapState("user", ["info", "innerHeight", "avatar", "init"]),
			...mapState("notice", ["notice_count"]),
		},
		watch: {
			levelList() {
				sessionStorage.setItem("level-list", JSON.stringify(this.levelList));
			}
		},
		methods: {
			//   判断是否初始化了仓库
			isInit() {
				if (this.app_id == 58) {
					if ((this.init.init_wms && this.init.init_wms != undefined) ||
						this.$route.name == "wareVmsShelf" ||
						this.$route.name == "wareVmsLocation") {
						return;
					}
					this.$router.push({ name: "newinit" });
				} else if (this.app_id == 59) {
					if (this.init.init_asset && this.init.init_asset != undefined) {
						return;
					}
					this.$router.push({ name: "assetnewInit" });
				}
			},
			findFirstLeaf(node) {
				if (node.children && node.children.length > 0) {
					return this.findFirstLeaf(node.children[0])
				} else {
					return node
				}
			},

			async selectApp(key) {
				this.loading = true;
				this.app_id = key;
				sessionStorage.setItem("app_id", this.app_id);
				let params = { name: "", app_id: this.app_id, prt_id: 0, page: 1 };
				this.resetCache()
				this.levelList = []
				this.childList = await access.getChild(params).then(res => res.data)
				const app = this.appList.find(v => v.id == key)
				if (app.expand_path) {
					this.$router.push(app.expand_path)
				} else {
					if (this.childList) {
						const firstLeaf = this.findFirstLeaf(this.childList[0])
						this.path = firstLeaf.path
						this.$router.push(this.path)
					}
				}
				this.loading = false
			},

			//选择左边
			handleselect: function (a) {
				this.find(a, this.childList);
				sessionStorage.setItem("current_path", this.path);
			},
			onMenuSelect(e) {
				if (e == this.$route.fullPath) return
				this.$route.meta.is_alive = false
				this.levelList = []
				this.resetCache()
				this.handleselect(e)

			},
			//退出登录
			logout: function () {
				this.$confirm("确认退出吗?", "提示", {
					type: "warning",
				}).then(() => {
					user.logout().then((res) => {
						this.$router.push("/login");
						clearAuthorization()
						sessionStorage.clear()
					});
				}).catch(() => { });
			},
			profile() {
				this.$router.push("/profile/info");
			},
			linkTo(item, index) {
				this.levelList.splice(index, this.levelList.length - index)
				console.log("this.levelList==>", this.levelList)
				this.$router.push(item.fullPath)
			},


			rmCache(key) {
				console.log("rmCache==>", key)
				if (this.$refs['content-view'] && this.$refs['content-view'].$vnode.parent) {
					const keys = this.$refs['content-view'].$vnode.parent.componentInstance.keys
					const ikey = keys.find(k => k.indexOf(key) > -1)

					delete this.$refs['content-view'].$vnode.parent.componentInstance.cache[ikey]
				}
			},
			resetCache() {
				if (this.$refs['content-view'] && this.$refs['content-view'].$vnode.parent) {
					this.$refs['content-view'].$vnode.parent.componentInstance.cache = {}
				}

			},
			find: function (path, list) {
				list.forEach((o) => {
					if (o.path == path) {
						this.path = path;
					} else {
						if (o.children) {
							this.find(path, o.children);
						}
					}
				});
			},

			bindWx() {
				this.qrcode.show = true;
				this.qrcode.loading = true;
				schoolUser.getBindQRcode().then((res) => {
					this.qrcode.loading = false;
					this.qrcode.url = res.data;
				});
			},



		},


		mounted() {
			this.app_id = sessionStorage.getItem("app_id");
			this.path = sessionStorage.getItem("current_path");
			const le = sessionStorage.getItem("level-list")
			if (le) {
				this.levelList = JSON.parse(le)
			}
			access.getMenu().then((res) => {
				this.appList = res.data;
				if (!this.app_id) {
					this.selectApp(this.appList[0].id);
				}
			});

			let params = { name: "", app_id: this.app_id, prt_id: 0, page: 1 };
			access.getChild(params).then((res) => {
				if (res.data) {
					this.childList = res.data;
					this.find(this.path, this.childList);
				}
				// if(res.code==0&&res.data.length==0){
				//     this.$message({ message:"暂无权限！", type: "info" });
				// }else{
				//     this.childList = res.data;
				//     this.find(this.path,this.childList);
				// }
			});

			let item = this.$route.meta;
			if (item.is_bread != undefined && item.is_bread == false) {
				this.is_show_bread = false;
			} else {
				this.is_show_bread = true;
			}

			this.$store.dispatch("user/current").then((res) => {
				if (res.data) {
					this.$store.dispatch('school/getCurrent')
					this.$store.dispatch('school/getConfig')
					this.$store.dispatch('school/getSchoolYearList')
					this.$store.dispatch('school/getGradeList')
					const token=getAuthorization()
					this.$store.commit('common/setAuthorization',token)
				}
			});
			this.$store.dispatch("notice/getMyNoticeNum");
			this.$store.dispatch("user/getConfig");
			this.$store.dispatch("user/getCurrentWeek");
			this.$store.commit("user/getinnerHeight");
		},
	};
</script>

<style scoped lang="scss">
	.content-container {
		background-image: url(../../assets/party-bg.png);
		background-repeat: no-repeat;
		background-size: 100% auto;
		background-position: bottom;
		position: relative;
		overflow: hidden;
	}
	.content-page {
		position: relative;
		width: 1000px;
		margin-left: calc(50% - 350px);
		margin-top: 20px;
	}
	.side-menu {
		width: 250px;
		top: 20px;
		position: absolute;
		left: calc(50% - 350px - 250px - 20px);
	}
	.top-header {
		background-color: #e54b4b;
		color: #fff;
		height: 50px;
		line-height: 50px;
		text-align: right;
		display: flex;
		justify-content: space-between;
		.user-name {
			font-size: 14px;
			color: #fff;
		}
		.avatar {
			border: 1px solid #fff;
			margin-left: 10px;
		}
		.iconfont {
			font-size: 25px;
			color: #fff;
		}
	}
	.middle-header {
		display: flex;
		margin-bottom: 4px;
		background-color: #fff;
		overflow-x: auto;
		overflow-y: hidden;
	}

	.el-badge /deep/ .el-badge__content {
		height: 14px;
		width: 14px;
		line-height: 14px;
		top: 10px;
		padding: 0;
	}

	.qrcode_image {
		width: 200px;
	}
	.el-aside {
		background-color: white;
		overflow: visible;
	}
	.logo {
		width: 200px;
		height: 80px;
		font-size: 22px;
		text-align: left;
		white-space: nowrap;

		line-height: 80px;
		img {
			width: 40px;
			height: 40px;
			vertical-align: middle;
		}
		label {
			font-size: 18px;
			color: black;
		}
	}

	.avatar {
		width: 24px;
		height: 24px;
		border-radius: 20px;
		vertical-align: middle;
		display: inline-block;
		margin-right: 6px;
	}

	.el-main {
		padding: 0;
		position: relative;
	}

	.el-menu--horizontal /deep/ .nva_item {
		text-align: center;
		height: 80px;
		padding: 0 40px;
		.icon {
			font-size: 30px;
			margin: 1px 0;
			line-height: 2;
		}
		.label {
			line-height: 1;
		}
	}
	.nva_item + .nva_item {
		margin-left: 2px;
		border-left: solid 1px #f5f5f9;
	}

	.msg-card {
		width: 200px;
		display: flex;
		border-bottom: solid 1px #f5f5f9;
		align-items: center;
		padding: 8px 0;
		.avatar {
			width: 30px;
			height: 30px;
			border-radius: 50%;
			margin-right: 15px;
		}
		.msg-card__title {
			line-height: 20px;
			font-size: 14px;
			color: black;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
		}
		.msg-card__content {
			line-height: 16px;
			margin-top: 6px;
			font-size: 12px;
			color: #888888;
			font-size: 12px;
			color: #888888;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
		}
	}
	.msg-card__body {
		font-size: 12px;
		color: #888888;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
	.breadcrumb {
		background-color: #ffffff;
		margin: 10 20 0 20;
		padding: 20px;
	}
	.out-row-2 {
		height: 100%;
		background-color: #f4f4f4;
		padding: 20px;
		margin: 0;
	}
	.out-row-1 {
		min-height: calc(100% - 60px);
		padding: 0 20;
		margin: 0 20;
		background-color: #ffffff;
	}
</style>



// WEBPACK FOOTER //
// src/views/party-build/home.vue